import { z } from "zod";

const VALID_PREFIXES = ["H", "HA", "U", "UA", "M", "MA"];
const TICKET_PATTERN = /^([A-Za-z]+)[\s\-_.]?(\d+)$/;
const PURE_DIGIT_PATTERN = /^\d+$/;

export function getTicketWarning(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  // Pure digits = número de albarán. Accepted because the backend resolves it
  // via sale_details.ticketNumber when there's no prefixed invoice (e.g. tickets
  // on credit / PETCO GROOMING). Albaranes are 1-5 digits today; allow up to 7.
  if (PURE_DIGIT_PATTERN.test(trimmed)) {
    if (trimmed.length > 7) return "Número de albarán demasiado largo";
    return null;
  }
  const match = trimmed.match(TICKET_PATTERN);
  if (!match) {
    return `Formato no reconocido. Usa el número de factura (letra de sucursal + dígitos, ej: U05434) o el número de albarán solo (ej: 16229).`;
  }
  const prefix = match[1].toUpperCase();
  const digits = match[2];
  if (!VALID_PREFIXES.includes(prefix)) {
    return `Prefijo "${prefix}" no válido. Los prefijos de sucursal válidos son: ${VALID_PREFIXES.join(", ")}`;
  }
  if (digits.length < 1 || digits.length > 5) {
    return `El número del ticket debe tener entre 1 y 5 dígitos (ej: H04550)`;
  }
  return null;
}

// Shared by the staff form (dashboard) and the client portal (facturación).
// superRefine, not refine: in zod 4 a function as refine's second argument is
// ignored and the field shows "Invalid input" instead of the warning.
export const invoiceRequestSchema = z.object({
  invoiceNumber: z.string().trim().min(1, "Requerido").superRefine((val, ctx) => {
    const warning = getTicketWarning(val);
    if (warning) ctx.addIssue({ code: "custom", message: warning });
  }),
  amount: z.string().min(1, "Requerido").regex(/^\d+(\.\d{1,2})?$/, "Monto inválido"),
});

export type InvoiceRequestFormData = z.infer<typeof invoiceRequestSchema>;
